import envVariables from '../../consts/envVariables';
import awsAuthService from '../aws/awsAuthService';
import {createClient} from '../dam/damClient';
import {createClientError} from '../dam/damClientError';

const getToken = ({isCookieAuth}) => {
    // DELETE of a session is authenticated by the gateway cookie, not the bearer
    if (isCookieAuth) return null;

    return awsAuthService.getCognitoAccessToken();
};

const createHeaders = (token) => {
    const headers = {'content-type': 'application/json'};

    if (token) headers.authorization = `Bearer ${token}`;

    return headers;
};

const createVoxlinkClient = () =>
    createClient({
        defaultEndpoint: envVariables.VOXLINK_API_ENDPOINT,
        createHeaders,
        clientError: createClientError(),
        logPrefix: 'voxlinkClient',
        getToken,
        withCredentials: true,
    });

let voxlinkClient = null;

// created on first use, not on import: awsAuthService imports this module,
// and at that moment damClient may not be initialised yet
const getVoxlinkClient = () => {
    if (!voxlinkClient) voxlinkClient = createVoxlinkClient();

    return voxlinkClient;
};

export default getVoxlinkClient;
